import React from "react";
import './index.css';
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from './src/layout/Layout'
import Home from "./src/pages/Home";
import About from "./src/pages/About";
import ServiceTemplate from "./src/pages/ServiceTemplate";
import Services from "./src/pages/Services";
import Contact from "./src/pages/Contact";
import Blogs from "./src/pages/Blogs";
import BlogTemplate from "./src/pages/BlogTemplate";
import MediaGallery from "./src/pages/MediaGallery";
import { HelmetProvider } from "react-helmet-async";

const useScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};


const App: React.FC = () => {

  useScrollToTop();

  return (
    <HelmetProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/:id" element={<ServiceTemplate />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:id" element={<BlogTemplate />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/media" element={<MediaGallery />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  )
}

export default App;